import ApplicationFeature from '^enums/ApplicationFeature';
import BusinessType from '^enums/BusinessType';

if (!window.xprops) {
  window.xprops = {
    brand: 'peugeot',
    modelCode: 'NY_308_Plug-In_Hybrid',
    businessType: BusinessType.Retail,
    configuratorUrl: '',
    features: [
      ApplicationFeature.CampaignVariantsSection,
      ApplicationFeature.VariantsSection,
      ApplicationFeature.TechnicalSpecificationsSection,
      ApplicationFeature.TrimEquipmentComparisonSection,
      ApplicationFeature.ColorsSection,
      ApplicationFeature.DownloadPdf,
      ApplicationFeature.ShowWidgetImage,
      ApplicationFeature.IsFirstColumnExpanded,
      ApplicationFeature.ChargingSubscriptionsSection,
      ApplicationFeature.InteriorsSection,
    ],
    selector: '',
    fixedElementsSelectors: [],
    isWidgetMode: false,
    parentUrl: window.location.href,
    autoCalculateSpacers: (): Promise<undefined> => Promise.resolve(undefined),
    scrollTo: (options: ScrollToOptions): Promise<void> => {
      window.scrollTo({
        ...options,
        behavior: 'smooth',
      });

      return Promise.resolve();
    },
    scrollToWidget: (): Promise<void> => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });

      return Promise.resolve();
    },
  };
}
